export const POSTING_NOTICE_TYPE = {
  DEFAULT: 'default',
  CARD: 'card',
  ICONIMAGE: 'iconImage'
} as const;

export type POSTING_NOTICE_TYPE_KEY = keyof typeof POSTING_NOTICE_TYPE;

export type POSTING_NOTICE_TYPE_VALUE =
  typeof POSTING_NOTICE_TYPE[POSTING_NOTICE_TYPE_KEY];

export const POSTING_NOTICE_TYPE_MAP = {
  [POSTING_NOTICE_TYPE.DEFAULT]: '기본 타입',
  [POSTING_NOTICE_TYPE.CARD]: '카드 타입',
  [POSTING_NOTICE_TYPE.ICONIMAGE]: '아이콘 이미지 타입',
};

export const postingNoticeTypeList = Object.keys(POSTING_NOTICE_TYPE_MAP).map(
  (key) => {
    return {
      key: key,
      value: POSTING_NOTICE_TYPE_MAP[key],
    };
  },
);